import { render, staticRenderFns } from "./my-swiper-card2.vue?vue&type=template&id=1086b826&scoped=true&"
import script from "./my-swiper-card2.vue?vue&type=script&lang=js&"
export * from "./my-swiper-card2.vue?vue&type=script&lang=js&"
import style0 from "./my-swiper-card2.vue?vue&type=style&index=0&id=1086b826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086b826",
  null
  
)

export default component.exports